"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyState = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../../hooks");
/**
 * # 📭 EmptyState
 *
 * A generic state used on screens or widgets that are empty or have no data.
 *
 * ## Usage
 * ```jsx
 * <EmptyState/>
 * ```
 */
const EmptyState = (props) => {
    const ComponentState = hooks_1.useComponent('ComponentState');
    return (react_1.default.createElement(ComponentState, Object.assign({ title: "Empty Area", description: "Create new items to fill this area." }, props)));
};
exports.EmptyState = EmptyState;
exports.EmptyState.displayName = 'EmptyState';
